import React, {
    useState,
    useEffect
}
from "react";

import {
    FontAwesomeIcon
}
from "@fortawesome/react-fontawesome";

import {
    faMagnifyingGlass,
    faBuilding,
    faChevronRight
}
from "@fortawesome/free-solid-svg-icons";

import {
    useHistory
}
from "react-router-dom";

import {
    functions
}
from "../../../../constants/common-functions";


export default function MobileSearchPanel()
{

    //--------------------------------------------------------
    // History
    //--------------------------------------------------------

    const history =
        useHistory();


    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [searchText, setSearchText] =
        useState("");

    const [locations, setLocations] =
        useState([]);


    //========================================================
    // Search
    //========================================================

    useEffect(
        function()
        {

            const value =
                searchText.trim();

            if(value.length > 3)
            {

                functions.getObjectFromAjax(
                    "/resolutionsoftwareplatform/facilitieslike?like=" +
                    encodeURIComponent(value),
                    setLocations,
                    null
                );

            }
            else
            {

                setLocations(
                    []
                );

            }

        },
        [searchText]
    );


    //========================================================
    // Events
    //========================================================

    const handleChange =
        function(event)
        {

            setSearchText(
                event.target.value
            );

        };


    const goBuilding =
        function(id)
        {

            history.push(
                "/facility/" + id
            );

        };


    //========================================================
    // Styles
    //========================================================

    const wrapper =
    {
        position:
            "relative",

        width:
            "100%",

        boxSizing:
            "border-box",

        zIndex:
            1000
    };


    const container =
    {
        display:
            "flex",

        alignItems:
            "center",

        width:
            "calc(100% - 20px)",

        height:
            "48px",

        margin:
            "10px",

        boxSizing:
            "border-box",

        padding:
            "0 16px",

        background:
            "rgba(255,255,255,0.72)",

        backdropFilter:
            "blur(16px)",

        WebkitBackdropFilter:
            "blur(16px)",

        border:
            "1px solid rgba(255,255,255,0.70)",

        borderRadius:
            "24px",

        boxShadow:
            "0 5px 16px rgba(0,0,0,0.12)"
    };


    const searchIcon =
    {
        color:
            "#5A9BD6",

        fontSize:
            "17px",

        marginRight:
            "11px",

        flexShrink:
            0
    };


    const input =
    {
        flexGrow:
            1,

        minWidth:
            0,

        height:
            "100%",

        margin:
            0,

        padding:
            0,

        border:
            "none",

        outline:
            "none",

        background:
            "transparent",

        color:
            "#26313D",

        fontSize:
            "14px",

        fontFamily:
            "inherit"
    };


    //========================================================
    // Results
    //========================================================

    const resultsContainer =
    {
        width:
            "calc(100% - 20px)",

        margin:
            "-4px 10px 10px 10px",

        background:
            "rgba(255,255,255,0.94)",

        backdropFilter:
            "blur(20px)",

        WebkitBackdropFilter:
            "blur(20px)",

        border:
            "1px solid rgba(255,255,255,0.75)",

        borderRadius:
            "14px",

        boxShadow:
            "0 10px 28px rgba(0,0,0,0.14)",

        overflow:
            "hidden",

        boxSizing:
            "border-box"
    };


    const resultsHeader =
    {
        padding:
            "9px 14px",

        background:
            "rgba(0,0,0,0.025)",

        borderBottom:
            "1px solid rgba(0,0,0,0.05)",

        color:
            "#7A8190",

        fontSize:
            "10px",

        fontWeight:
            "700",

        letterSpacing:
            "0.6px",

        textTransform:
            "uppercase"
    };


    const resultRow =
    {
        display:
            "flex",

        alignItems:
            "center",

        width:
            "100%",

        minHeight:
            "48px",

        padding:
            "10px 14px",

        boxSizing:
            "border-box",

        borderBottom:
            "1px solid rgba(0,0,0,0.05)",

        cursor:
            "pointer"
    };


    const buildingIcon =
    {
        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "center",

        width:
            "32px",

        height:
            "32px",

        marginRight:
            "11px",

        flexShrink:
            0,

        borderRadius:
            "50%",

        background:
            "rgba(90,155,214,0.10)",

        color:
            "#5A9BD6",

        fontSize:
            "13px"
    };


    const resultName =
    {
        flexGrow:
            1,

        minWidth:
            0,

        color:
            "#26313D",

        fontSize:
            "13px",

        fontWeight:
            "600"
    };


    const arrow =
    {
        marginLeft:
            "10px",

        color:
            "#9AA1AC",

        fontSize:
            "11px"
    };


    //========================================================
    // Render
    //========================================================

    return (

        <div style={wrapper}>


            {/* ==============================================
                SEARCH
            ============================================== */}

            <div style={container}>

                <FontAwesomeIcon
                    icon={faMagnifyingGlass}
                    style={searchIcon}
                />

                <input
                    type="text"

                    value={searchText}

                    placeholder="Search OmniScan..."

                    style={input}

                    onChange={handleChange}
                />

            </div>


            {/* ==============================================
                RESULTS
            ============================================== */}

            {
                locations.length > 0
                &&
                <div style={resultsContainer}>

                    <div style={resultsHeader}>

                        Matching Buildings

                    </div>

                    {
                        locations.map(
                            function(item)
                            {

                                return (

                                    <div
                                        key={item.id}

                                        style={resultRow}

                                        onClick={
                                            function()
                                            {

                                                goBuilding(
                                                    item.id
                                                );

                                            }
                                        }
                                    >

                                        <div style={buildingIcon}>

                                            <FontAwesomeIcon
                                                icon={faBuilding}
                                            />

                                        </div>

                                        <div style={resultName}>

                                            {item.name}

                                        </div>

                                        <FontAwesomeIcon
                                            icon={faChevronRight}
                                            style={arrow}
                                        />

                                    </div>

                                );

                            }
                        )
                    }

                </div>
            }

        </div>

    );

}